import { Redirect, useLocalSearchParams } from 'expo-router'

import { FraternityLeadScreen } from '@/src/features/fraternity/ui/screens/FraternityLeadScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

const CommunityJoinLeadRouterPage = () => {
  const searchParams = useLocalSearchParams()
  const { idSlug } = filterSearchParams<TIdSlugParam>(searchParams)

  if (!idSlug) return <Redirect href="not-found" />

  return <FraternityLeadScreen idSlug={idSlug} searchParams={searchParams} />
}

export default CommunityJoinLeadRouterPage
